import TextInput from '@standardsdigital/ui-components/TextInput';
import { useTranslation } from 'react-i18next';
import type { UseFormRegister } from 'react-hook-form';
import FieldStatusWrapper from 'components/global/FieldStatusWrapper/FieldStatusWrapper';
import type { ServiceLevelFormValues } from '../../../serviceLevelOptions';
import { messageSeverity } from './formInputHelpers';

interface NameInputProps {
  register: UseFormRegister<ServiceLevelFormValues>;
  error?: string;
  isDirty: boolean;
  disabled: boolean;
}

function NameInput({
  register,
  error,
  isDirty,
  disabled,
}: Readonly<NameInputProps>) {
  const { t } = useTranslation();

  return (
    <FieldStatusWrapper isDirty={isDirty}>
      <TextInput
        {...register('serviceLevelName')}
        id="serviceLevelName"
        label={t('serviceLevels.form.name')}
        message={error}
        severity={messageSeverity(error)}
        required
        disabled={disabled}
      />
    </FieldStatusWrapper>
  );
}

export default NameInput;
